module.exports = __webpack_public_path__ + "static/media/icon-csv.db03efaf.svg";